export const SET_MEET_PEOPLE_DATA = 'SET_MEET_PEOPLE_DATA';